import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import {Grid,Cell,Button, DialogContainer, Card} from 'react-md';
import Calculator from './../../components/Calculator';
import KeyBoardInstruction from './../../components/KeyBoardInstruction';
import styles from '../../css/styles.css';
import Draggable from 'react-draggable';
import { isBrowser, isMobile,isTablet } from 'react-device-detect';

//CSS Import
//import '../../css/TakeQuizContainer.css'

class TakeQuizContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            showCalciDialog: false,
            showHelpDialog: false,
            makeError: false,
        };
        console.debug("isBrowser, isMobile,isTablet ",props, isBrowser, isMobile,isTablet)
        this.closeCalculatorDialog = this.closeCalculatorDialog.bind(this);
        this.showCalculatorDialog = this.showCalculatorDialog.bind(this);
        this.closeHelpDialog = this.closeHelpDialog.bind(this);
        this.showHelpDialog = this.showHelpDialog.bind(this);
        this.keyDownEventFunction = this.keyDownEventFunction.bind(this);
        this.breakTheApp = this.breakTheApp.bind(this);
    }

    componentDidMount(){
        window.addEventListener("keydown", this.keyDownEventFunction);
    }

    componentWillUnmount(){
        window.removeEventListener("keydown", this.keyDownEventFunction);
    }

    keyDownEventFunction(e){
        if(e.key === "?"){
            e.preventDefault();
            this.setState(prevState=>({showHelpDialog: !prevState.showHelpDialog}));
        }
    }

showCalculatorDialog() {
    this.setState({
        showCalciDialog: true
    });
}

showHelpDialog() {
    this.setState({
        showHelpDialog: true
    });
}

closeCalculatorDialog() {
    this.setState({
        showCalciDialog: false
    });
}

closeHelpDialog() {
    this.setState({
        showHelpDialog: false
    });
}

breakTheApp() {
    if (this.props.isDebug) {
        this.setState({
            makeError: true
        })
    }
}

render() {
    const hideElement = {display:"none"}
    if (this.state.makeError) {
        BreakTheApp
        return
    }
    return  <Grid className="noMarigin noPadding" id="quizContainer">

    {this.props.isTest === 0 ? <Cell style={this.props.hideTitle?hideElement:{}} size={6}><h1 className="text-color-primary">{this.props.title}</h1>
    <h4>{this.props.practiceCount > 0 ? "(This is a nongraded practice attempt. Your grade will not be affected by this attempt)" :""}</h4>
    </Cell> : 
    <Cell style={this.props.hideTitle?hideElement:{}} size={8}><h1 className="text-color-primary">{this.props.title}</h1>
    <h4>{this.props.practiceCount > 0 ? "(This is a nongraded practice attempt. Your grade will not be affected by this attempt)" :""}</h4></Cell>}
    {/*bug id 251*/}
    <Cell size={this.props.isTest === 1 ? 4 : 6}>
        <Grid container="true">
            {
            //isBrowser === true && 
            this.props.isTest === 0 ?
            <React.Fragment>
                <Cell style={{textAlign:'right'}} size={4} phoneSize={4}> 
                    <Button flat primary style={{...styles.calciButton, paddingLeft:"6px", paddingRight:"6px", textAlign:"center"}} onTouchStart={this.showHelpDialog} onClick={this.showHelpDialog}>Keyboard Shorcuts</Button>
                </Cell> 
                <Cell style={{textAlign:'right'}} size={4} phoneSize={4}> 
                    <Button flat primary style={styles.calciButton} onTouchStart={this.showCalculatorDialog} onClick={this.showCalculatorDialog}>Calculator</Button>
                </Cell> 
                {this.props.showFreeChoice && this.props.courseID !== -1 ? 
                <Cell style={{textAlign:'right'}} size={4} phoneSize={4}> 
                    <Button onClick={this.props.onShowCategorySelection} style={{backgroundColor: "#1B75BC", color: "#ffffff"}}
                                    flat swapTheming>Category List</Button>
                </Cell> 
                :""}
            </React.Fragment>
            : '' }
            {this.props.isTest === 0 || (this.props.isTest === 1 && this.props.isAbsoluteTimerOn === 0)
            ?
            <Cell style={{textAlign:'right'}} size={this.props.isTest === 1 ? 6 : 4} phoneSize={4}>
                <Button onClick={this.props.onSaveAndExit} flat primary swapTheming>Save and Exit</Button>
            </Cell>
            :''}
            {this.props.isDebug ?
                <React.Fragment>
                <Cell style={{textAlign:'right'}} size={ 4} phoneSize={4}>
                    <Button onClick={this.props.onResetToPreviousGNB} flat primary swapTheming>Reset GNB</Button>
                </Cell>
                <Cell style={{textAlign:'right'}} size={ 4} phoneSize={4}>
                    <Button onClick={this.props.loadStateFromLocalStorage} flat primary swapTheming>Load State</Button>
                </Cell>
                <Cell style={{textAlign:'right'}} size={ 4} phoneSize={4}>
                    <Button onClick={this.breakTheApp} flat primary swapTheming>Break the app</Button>
                </Cell>
                <Cell style={{textAlign:'right'}} size={ 4} phoneSize={4}>
                    <Button onClick={this.props.dummyClientLogApiCall} flat primary swapTheming>Debug Client Log</Button>
                </Cell>
                </React.Fragment> :("")
            }
        </Grid>
    </Cell>
    
    <Cell style={{paddingBottom:'50px'}} size={2} phoneSize={6}>{this.props.rightPane}</Cell>
    <Cell size={10} phoneSize={6}>
        <Grid className="noMarigin noPadding ">
            <Cell  className="noMarigin noPadding fullWidth" size={12} >{this.props.contentPane}</Cell>
            <Cell size={12}>{this.props.bottomPane}</Cell>
        </Grid>
    </Cell>
    
{/*     <Grid className="noMarigin noPadding "> */}
    {this.state.showCalciDialog ? 
            <Draggable>
            <Cell style= {isMobile ?{ position: 'absolute', top: '150px', right: '55px',height:'fit-content',width:'fit-content'} :
            isTablet ? { position: 'absolute', top: '400px', right: '55px',height:'fit-content',width:'fit-content'} :
            { position: 'absolute', top: '100px', right: '100px',height:'fit-content',width:'fit-content'}}>
                    <div style={{color:'white', float: 'right', backgroundColor: 'gray', textAlign: 'center' }}>
                        Click here to drag
                        <Card className="md-block-centered">
                        <Calculator/>
                        <center>
                            <Button flat primary swapTheming onTouchStart={this.closeCalculatorDialog} onClick={this.closeCalculatorDialog}>Close</Button></center>
                        </Card>
                    </div>
            </Cell>
            </Draggable>
     : ''}
     {this.state.showHelpDialog ? 
            <DialogContainer
            id="keyboard-instruction"
            title="Keyboard Shortcuts"
            visible={this.state.showHelpDialog}
            width="800px"
            contentStyle={{height : "360px"}}
            titleStyle={{color: '#576271', fontSize : "18px"}}
            aria-describedby="keyboard-shortcut-instructions"
            modal
        >
            {/* currentQuestionType == 4 is Reasoning Chain type question */}
            {this.props.currentQuestionType === 4 ? 
            
            <Grid size={12} style={{marginBottom:"10px"}}>
                <Cell size={6} phoneSize={4}> 
                    <KeyBoardInstruction Keys={["Tab"]} Instruction={"Change field selection"}/>
                    <KeyBoardInstruction Keys={["Shift","Tab"]} Instruction={"Go to previous field selection"}/>
                    <KeyBoardInstruction Keys={["Enter"]} Instruction={"Confirm selection and proceed"}/>
                </Cell>
                <Cell size={6} phoneSize={4}> 
                    <KeyBoardInstruction Keys={["→"]} Instruction={"Go to the submenu inside the current item"}/>
                    <KeyBoardInstruction Keys={["←"]} Instruction={"Return to the main menu from the submenu"}/>
                    <KeyBoardInstruction Keys={["↑"]} Instruction={"Move to the previous item in the menu"}/>
                    <KeyBoardInstruction Keys={["↓"]} Instruction={"Move to the next item in the menu"}/>
                </Cell>
            </Grid> 
            :

            <Grid size={12} style={{marginBottom:"10px"}}>
            <Cell size={6} phoneSize={4}> 
            <KeyBoardInstruction Keys={["?"]} Instruction={"Toggle keyboard shortcuts help dialog"}/>
            <KeyBoardInstruction Keys={["Tab"]} Instruction={"Change field selection"}/>
            <KeyBoardInstruction Keys={["Shift","Tab"]} Instruction={"Go to previous field selection"}/>
            <KeyBoardInstruction Keys={["Space"]} Instruction={"Change radio button selection"}/>
            <KeyBoardInstruction Keys={["↑"]} Instruction={"Move vector head y+ axis"}/>
            <KeyBoardInstruction Keys={["↓"]} Instruction={"Move vector head y- axis"}/>
            
            </Cell>
            <Cell size={6} phoneSize={4}>
            <KeyBoardInstruction Keys={["→"]} Instruction={"Move vector head x+ axis"}/>
            <KeyBoardInstruction Keys={["←"]} Instruction={"Move vector head x- axis"}/>
            <KeyBoardInstruction Keys={["Shift","↑"]} Instruction={"Move vector y+ axis"}/>
            <KeyBoardInstruction Keys={["Shift","↓"]} Instruction={"Move vector y- axis"}/>
            <KeyBoardInstruction Keys={["Shift","→"]} Instruction={"Move vector x+ axis"}/>
            <KeyBoardInstruction Keys={["Shift","←"]} Instruction={"Move vector x- axis"}/> 
            </Cell>
            </Grid>
            }
            
            <center><Button flat primary swapTheming onTouchStart={this.closeHelpDialog} onClick={this.closeHelpDialog}>Close</Button></center>
        </DialogContainer>
     : ''}
{/*     </Grid> */}
    
{/*     <DialogContainer width="auto" visible={this.state.showCalciDialog}>
        <Calculator/>
        <center><Button flat primary swapTheming onClick={this.closeCalculatorDialog}>Close</Button></center>
    </DialogContainer> */}
{/*     {isBrowser &&  this.state.showCalciDialog ? <Cell size={6}> <Draggable><div style={{ float: 'right', borderStyle: 'solid', textAlign: 'center' }}>
    <Calculator/>
    <center><Button flat primary swapTheming onTouchStart={this.closeCalculatorDialog} onClick={this.closeCalculatorDialog}>Close</Button></center>
    </div></Draggable></Cell> : ''} */}
</Grid>
}
};
/*
TakeQuizContainer.propTypes = {
    title: PropTypes.string.isRequired,
    splashText: PropTypes.string,
    onStartClick:PropTypes.func.isRequired,
};
*/
export default TakeQuizContainer;